module.exports = __webpack_public_path__ + "img/garage_door.49a6812.svg";